export default function() {
  return typeof window !== "undefined"
    ? window.location.hash.replace(/^#/g, "")
    : "";
}
